<template>
    <v-layout
        wrap
        align-start
    >
        <v-flex xs12>
            <v-card class="card--flex-toolbar">
                <v-toolbar
                    flat
                    @click="mostrar_filtros_model = !mostrar_filtros_model"
                >
                    <v-toolbar-title class="grey--text">
                        Pedidos
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon>
                        <v-icon>{{ mostrar_filtros_model ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-slide-y-transition>
                    <v-container
                        v-show="mostrar_filtros_model"
                        grid-list-md
                    >
                        <v-layout wrap>
                            <v-form>
                                <v-layout wrap>
                                    <v-flex
                                        xs12
                                        md4
                                    >
                                        <v-dialog
                                            ref="dialog"
                                            v-model="modal_desde"
                                            :return-value.sync="filter.desde"
                                            persistent
                                            full-width
                                            width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    v-model="filter.desde"
                                                    label="Desde:"
                                                    prepend-icon="event"
                                                    readonly
                                                    clearable
                                                    @click:clear="filter.hasta = null"
                                                    v-on="on"
                                                />
                                            </template>
                                            <v-date-picker
                                                v-model="filter.desde"
                                                locale="es-MX"
                                                scrollable
                                            >
                                                <v-spacer/>
                                                <v-btn
                                                    color="gray"
                                                    @click="modal_desde = false"
                                                >
                                                    Cancelar
                                                </v-btn>
                                                <v-btn
                                                    color="primary"
                                                    @click="$refs.dialog.save(filter.desde)"
                                                >
                                                    Aceptar
                                                </v-btn>
                                            </v-date-picker>
                                        </v-dialog>
                                    </v-flex>
                                    <v-flex
                                        xs12
                                        md4
                                    >
                                        <v-dialog
                                            ref="dialog2"
                                            v-model="modal_hasta"
                                            :return-value.sync="filter.hasta"
                                            persistent
                                            full-width
                                            width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    v-model="filter.hasta"
                                                    label="Hasta:"
                                                    prepend-icon="event"
                                                    :disabled="filter.desde === null"
                                                    readonly
                                                    clearable
                                                    v-on="on"
                                                />
                                            </template>
                                            <v-date-picker
                                                v-model="filter.hasta"
                                                :min="filter.desde"
                                                locale="es-MX"
                                                scrollable
                                            >
                                                <v-spacer/>
                                                <v-btn
                                                    color="gray"
                                                    @click="modal_hasta = false"
                                                >
                                                    Cancelar
                                                </v-btn>
                                                <v-btn
                                                    color="primary"
                                                    @click="$refs.dialog2.save(filter.hasta)"
                                                >
                                                    Aceptar
                                                </v-btn>
                                            </v-date-picker>
                                        </v-dialog>
                                    </v-flex>
                                    <v-flex
                                        xs12
                                        md4
                                    >
                                        <v-select
                                            v-model="filter.anonimo"
                                            :items="[{value : -1 , text: 'Todos'},{value : 0, text : 'Registrados'},{value : 1 , 'text' : 'Anónimos'}]"
                                            menu-props="auto"
                                            label="Tipo de cuenta"
                                            hide-details
                                            prepend-icon="visibility"
                                        />
                                    </v-flex>
                                    <v-flex
                                        xs12
                                        md4
                                    >
                                        <v-select
                                            v-model="filter.estatus_id"
                                            :items="estatus_list"
                                            menu-props="auto"
                                            label="Estatus del pedido"
                                            hide-details
                                            prepend-icon="flag"
                                        />
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-layout>
                    </v-container>
                </v-slide-y-transition>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                        color="blue darken-1"
                        class="white--text"
                        :loading="loading"
                        :disabled="loading"
                        @click="listar"
                    >
                        Buscar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-flex>
        <v-flex
            grow
            pt-2
        >
            <v-data-table
                :headers="headers"
                :items="pedidos"
                item-key="id"
                :options.sync="options"
                class="elevation-1"
                no-data-text="No hay registros disponibles"
                :loading="loading"
                :server-items-length="pedidosTotal"
                :footer-props="{rowsPerPageText : 'Pedidos por página'}"
                @update:options="listar"
            >
                <template v-slot:body="{items}">
                    <tbody>
                    <tr v-for="item in items" :key="item.id" :style="{'background':item.estatus.color}">
                        <td>{{ item.anonimo ? item.anonimo_detalles.direccion.direccion :
                            item.direccion.direccion }}
                        </td>
                        <td class="justify-center layout px-0">
                            <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                    <v-icon
                                        tooltip="aaa"
                                        medium
                                        class="mr-2"
                                        color="blue lighten-2"
                                        v-on="on"
                                        @click="pedido_select = item; dialog_change_status = true;"
                                    >
                                        flag
                                    </v-icon>
                                </template>
                                <span>Cambiar estatus</span>
                            </v-tooltip>
                            <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                    <v-icon
                                        medium
                                        class="mr-2"
                                        v-on="on"
                                        @click="$router.push({name : 'pedido-detalles', params : {pedidoId : item.id}})"
                                    >
                                        visibility
                                    </v-icon>
                                </template>
                                <span>Ver pedido</span>
                            </v-tooltip>
                            <!--<v-icon
                                          small
                                          @click="deleteItemConfirm(props.item)"
                                      >
                                          delete
                                      </v-icon>-->
                        </td>
                    </tr>
                    </tbody>
                </template>
            </v-data-table>
        </v-flex>

        <v-dialog
            v-model="dialog_delete"
            max-width="600px"
            persistent
        >
            <v-card>
                <v-card-title>
                    <span class="headline">Cancelar pedido</span>
                </v-card-title>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                        color="gray darken-1"
                        flat
                        @click="dialog_delete = false"
                    >
                        No
                    </v-btn>
                    <v-btn
                        color="red darken-1"
                        class="white--text"
                        :loading="loading_cancelar"
                        :disabled="loading_cancelar"
                        @click="deleteItem"
                    >
                        Si
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar
            v-model="snackbar"
            rigth
            top
            :color="snackbar_config.color"
            :multi-line="snackbar_config.multi_line"
            :timeout="snackbar_config.timeout"
            :vertical="snackbar_config.mobile"
        >
            <div v-html="snackbar_config.text_content"/>
            <v-btn
                dark
                flat
                @click="snackbar = false"
            >
                Cerrar
            </v-btn>
        </v-snackbar>
        <v-dialog
            v-model="dialog_change_status"
            max-width="600px"
        >
            <form-change-status
                v-if="dialog_change_status"
                :pedido-id="pedido_select.id"
                :estatus-actual="pedido_select.estatus_id"
                @form:close="dialog_change_status = false"
                @form:save="estatusCambiado"
            />
        </v-dialog>
    </v-layout>
</template>

<script>

    import axios from 'axios';
    import FormChangeStatus from '@components/FormChangeStatus';

    export default {
        name: "PedidosVendedor",
        components: {
            FormChangeStatus
        },
        data: () => ({
            dialog: false,
            dialog_delete: false,
            dialog_change_status: false,
            // estatus_list: [{value: 0, text: 'Todos'}],
            headers: [
                {
                    text: 'Dirección',
                    align: 'left',
                    sortable: false,
                    value: 'direccion',
                },
                {
                    text: 'Actions',
                    value: 'actions',
                    sortable: false,
                    width: '100px'
                }
            ],
            pedidos: [],
            pedidosTotal : 0,
            itemSelectId: 0,
            itemDelete: null,
            loading: false,
            loading_cancelar: false,
            loading_estatus: false,
            options: {
                descending:true,
                page:1,
                itemsPerPage:10,
                totalItems:0
            },
            pedido_select: null,
            snackbar: false,
            snackbar_config: {
                color: '',
                multi_line: false,
                timeout: 6000,
                mobile: false,
                text_content: '',
            },
            filter: {
                desde: null,
                hasta: null,
                cuenta_id: null,
                anonimo: -1,
                estatus_id: 0
            },
            modal_desde: false,
            modal_hasta: false,
            mostrar_filtros_model: false
        }),
        computed: {
            estatus_list(){
                return [{value: 0, text: 'Todos'}].concat(this.$root.estatus_all);
            },
            editItem() {
                if (this.itemSelectId) {
                    return this.pedidos.find((item) => item.id === this.itemSelectId)
                } else {
                    return {}
                }
            },
            mostrar_filtros() {
                return this.$vuetify.breakpoint.xs || this.mostrar_filtros_model;
            }
        },

        watch: {
            dialog(val) {
                val || this.close()
            }
        },

        created() {
            this.initialize()
        },
        mounted() {
            this.listarStatus();
        },
        methods: {
            initialize() {
            },
            close() {
                this.dialog = false;
                this.itemSelectId = 0;
            },
            editItemId(itemId) {
                this.itemSelectId = parseInt(itemId);
                this.dialog = true
            },
            estatusCambiado() {
                this.dialog_change_status = false;
                this.listar();
            },
            deleteItem() {
                this.loading_cancelar = true;
                axios.post('/api/pedidos/cancelar/' + this.itemDelete.id)
                    .then((response) => {
                        this.loading_cancelar = false;
                        let {data} = response;
                        if (data.success) {
                            this.snackbar_config.color = 'success';
                            this.snackbar_config.text_content = data.message;
                            this.snackbar = true;
                            this.itemDelete = null;
                            this.dialog_delete = false;
                            this.listar();
                        }
                    })
                    .catch((error) => {
                        this.loading_cancelar = false;
                        this.snackbar_config.color = 'error';
                        if (error.response && error.response.data) {
                            this.snackbar_config.text_content = error.response.data.message;
                            this.snackbar = true;
                        } else {
                            this.snackbar_config.text_content = 'Error durante la petición';
                            this.snackbar = true;
                        }
                    })
            },
            deleteItemConfirm(item) {
                this.itemDelete = item;
                this.dialog_delete = true;
            },
            listar() {
                this.loading = true;
                const {sortBy, descending, page, itemsPerPage} = this.options;
                axios.get('/api/pedidos/listar', {
                    params: {
                        sortBy: sortBy, descending: descending, page: page, rowsPerPage: itemsPerPage,
                        search: this.search,
                        ...this.filter
                    }
                })
                    .then((success) => {
                        this.loading = false;
                        let {data} = success;
                        this.pedidos = data.data;
                        this.pedidosTotal = data.total;
                        this.options.page = data.current_page;
                    })
            },
            saveItem() {
                this.dialog = false;
                this.listar();
            },
            listarStatus() {
                // this.loading_estatus = true;
                // console.log("pedidosVendedor");
                // axios.get('/api/pedidos/listar-estatus')
                //     .then((response) => {
                //         let {data} = response;
                //         let fill = this.estatus_list.concat(data.data);
                //         this.estatus_list = Object.assign(fill);
                //         this.loading_estatus = false;
                //     }).catch(() => {
                //
                // })
            }
        }
    }
</script>

<style scoped>

</style>
